module.exports = __webpack_public_path__ + "img/bg-woman.e8b65c30.svg";